import { FC } from "react";
import { Link, LinkProps } from "react-router";

import styles from "./InternalLink.module.css";

interface InternalLinkProps extends LinkProps {
  to: string;
}

const InternalLink: FC<InternalLinkProps> = ({ to, onClick, children, ...rest }) => {
  const isInternal = to[0] === "/";

  if (isInternal) {
    return (
      <Link
        download={rest.download}
        to={to}
        onClick={onClick}
        {...rest}
        className={styles.InternalLink}
      >
        {children}
      </Link>
    );
  } else {
    // Also internal, but with a URL that includes a hostname, like file downloads
    return (
      <a
        download={rest.download}
        href={to}
        onClick={onClick}
        {...rest}
        className={styles.InternalLink}
      >
        {children}
      </a>
    );
  }
};

export default InternalLink;
